import { render, staticRenderFns } from "./SubtitleTotals.vue?vue&type=template&id=f4bcfdb2"
import script from "./SubtitleTotals.vue?vue&type=script&lang=js"
export * from "./SubtitleTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports